<template>
  <div class="common-add-button">
    <div @click="click()" class="flex items-center">
      <feather-icon :icon="icon" class="mr-1" svg-classes="h-6 w-6" />
      <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    click: {
      type: Function,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";
.common-add-button {
  font-size: 14px;
  font-family: $aisea-font-family;
  font-weight: 600;
  color: $common-text-dark-gray;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    color: $blue-button-default;
  }
}
</style>
